import { render, staticRenderFns } from "./ResumenCard.vue?vue&type=template&id=87dd0766&scoped=true"
import script from "./ResumenCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumenCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResumenCard.vue?vue&type=style&index=0&id=87dd0766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dd0766",
  null
  
)

export default component.exports